import React, { useEffect, useState, useContext, useRef } from "react";
import { AuthContext } from "../context/AuthContext";
import "../css/ActivateUser.css";

const ActivateUsers = () => {
  const { getPendingUsers, approveUser } = useContext(AuthContext);

  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const prevCount = useRef(0);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const data = await getPendingUsers();

        // ✅ Always normalize response
        if (Array.isArray(data)) {
          setUsers(data);

          // 🔔 Optional: new user notification
          if (prevCount.current && data.length > prevCount.current) {
            console.log("New user request received");
          }
          prevCount.current = data.length;
        } else {
          console.error("Unexpected response:", data);
          setUsers([]);
        }
      } catch (error) {
        console.error("Failed to fetch pending users:", error.message);
        setUsers([]);
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
    const interval = setInterval(fetchUsers, 15000);

    return () => clearInterval(interval);
  }, [getPendingUsers]);

  const handleAction = async (userId, action) => {
    if (!window.confirm(`Are you sure you want to ${action} this user?`)) return;

    try {
      const res = await approveUser(userId, action);

      if (res && res.ok) {
        setUsers((prev) => prev.filter((u) => u.id !== userId));
        alert(`User ${action}d successfully`);
      } else {
        alert(res?.message || "Action failed");
      }
    } catch (error) {
      console.error("Action error:", error);
      alert("Server error");
    }
  };

  if (loading) {
    return <h2 style={{ textAlign: "center" }}>Loading pending users...</h2>;
  }

  return (
    <div className="activate-users-container">
      <h1>Pending User Requests</h1>

      {users.length === 0 ? (
        <p>No pending approvals 🎉</p>
      ) : (
        <table className="activate-users-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Name</th>
              <th>Address</th>
              <th>Email</th>
              <th>Phone number</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {Array.isArray(users) &&
              users.map((u) => (
                <tr key={u.id}>
                  <td data-label="ID">{u.id}</td>
                  <td data-label="Name">{u.name}</td>
                  <td data-label="Address">{u.address}</td>
                  <td data-label="Email">{u.email}</td>
                  <td data-label="phone">{u.phone}</td>
                  <td data-label="Status">
                    <span className="status-pending">Pending</span>
                  </td>
                  <td data-label="Action">
                    <button
                      className="btn-approve"
                      onClick={() => handleAction(u.id, "approve")}
                    >
                      Approve
                    </button>
                    <button
                      className="btn-deny"
                      onClick={() => handleAction(u.id, "deny")}
                    >
                      Deny
                    </button>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default ActivateUsers;
